import { CSSProperties } from 'react'

export const s = {
  sideWrapper: {
    height: 'calc(100vh - 106px)',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    position: 'fixed',
    borderRight: '1px solid #f0f0f0',
    paddingLeft: '40px',
    left: 0,
    width: 'calc((100vw - 1278px) / 2 + 309px)',
  } as CSSProperties,
  mainContent: {
    margin: '40px 0px 36px 358px',
  } as CSSProperties,
}
